export const INPUT = 'INPUT';

export const DETALIZATION_PAGE_ACTIONS = {
  SET_CURRENT_DETALIZATION_MODAL: 'DETALIZATION_PAGE:SET_CURRENT_DETALIZATION_MODAL',
};
